import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "kt_aside_menu_wrapper",
  ref: "scrollElRef",
  class: "hover-scroll-overlay-y my-5 my-lg-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "0",
  "data-kt-scroll-wrappers": "#kt_aside_menu"
}
const _hoisted_2 = {
  id: "#kt_header_menu",
  class: "menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500",
  "data-kt-menu": "true"
}
const _hoisted_3 = { class: "menu-item" }
const _hoisted_4 = ["href", "onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home fs-3" })
], -1)
const _hoisted_6 = { class: "menu-title" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "separator" })
  ])
], -1)
const _hoisted_8 = { class: "menu-item" }
const _hoisted_9 = { class: "menu-content pt-5 pb-2" }
const _hoisted_10 = { class: "menu-section text-muted text-uppercase fs-8 ls-1" }
const _hoisted_11 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_12 = ["href", "onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder-open fs-3" })
], -1)
const _hoisted_14 = { class: "menu-title" }
const _hoisted_15 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_16 = ["href", "onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-line fs-3" })
], -1)
const _hoisted_18 = { class: "menu-title" }
const _hoisted_19 = {
  key: 2,
  class: "menu-item"
}
const _hoisted_20 = ["href", "onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-poll fs-3" })
], -1)
const _hoisted_22 = { class: "menu-title" }
const _hoisted_23 = {
  key: 3,
  class: "menu-item"
}
const _hoisted_24 = ["href", "onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marked-alt fs-3" })
], -1)
const _hoisted_26 = { class: "menu-title" }
const _hoisted_27 = {
  key: 4,
  class: "menu-item"
}
const _hoisted_28 = ["href", "onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lightbulb fs-3" })
], -1)
const _hoisted_30 = { class: "menu-title" }
const _hoisted_31 = {
  key: 5,
  class: "menu-item"
}
const _hoisted_32 = ["href", "onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chalkboard-teacher fs-3" })
], -1)
const _hoisted_34 = { class: "menu-title" }
const _hoisted_35 = {
  key: 6,
  class: "menu-item"
}
const _hoisted_36 = ["href", "onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye fs-3" })
], -1)
const _hoisted_38 = { class: "menu-title" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "separator" })
  ])
], -1)
const _hoisted_40 = { class: "menu-item" }
const _hoisted_41 = { class: "menu-content pt-5 pb-2" }
const _hoisted_42 = { class: "menu-section text-muted text-uppercase fs-8 ls-1" }
const _hoisted_43 = {
  key: 8,
  class: "menu-item"
}
const _hoisted_44 = { class: "menu-item" }
const _hoisted_45 = ["href", "onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users fs-3" })
], -1)
const _hoisted_47 = { class: "menu-title" }
const _hoisted_48 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_49 = ["href", "onClick"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sitemap fs-3" })
], -1)
const _hoisted_51 = { class: "menu-title" }
const _hoisted_52 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_53 = ["href", "onClick"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell fs-3" })
], -1)
const _hoisted_55 = { class: "menu-title" }
const _hoisted_56 = {
  key: 2,
  class: "menu-item menu-accordion",
  "data-kt-menu-sub": "accordion",
  "data-kt-menu-trigger": "click"
}
const _hoisted_57 = { class: "menu-link" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-pie" })
], -1)
const _hoisted_59 = { class: "menu-title" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_61 = { class: "menu-sub menu-sub-accordion" }
const _hoisted_62 = { class: "menu-item" }
const _hoisted_63 = ["href", "onClick"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_65 = { class: "menu-title" }
const _hoisted_66 = { class: "menu-item" }
const _hoisted_67 = ["href", "onClick"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_69 = { class: "menu-title" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "separator" })
  ])
], -1)
const _hoisted_71 = { class: "menu-item" }
const _hoisted_72 = { class: "menu-content pt-5 pb-2" }
const _hoisted_73 = { class: "menu-section text-muted text-uppercase fs-8 ls-1" }
const _hoisted_74 = { class: "menu-item" }
const _hoisted_75 = ["href", "onClick"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cogs fs-3" })
], -1)
const _hoisted_77 = { class: "menu-title" }
const _hoisted_78 = { class: "menu-item" }
const _hoisted_79 = ["href", "onClick"]
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-universal-access fs-3" })
], -1)
const _hoisted_81 = { class: "menu-title" }
const _hoisted_82 = { class: "menu-item" }
const _hoisted_83 = ["href", "onClick"]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users-cog fs-3" })
], -1)
const _hoisted_85 = { class: "menu-title" }
const _hoisted_86 = {
  class: "menu-item menu-accordion",
  "data-kt-menu-sub": "accordion",
  "data-kt-menu-trigger": "click"
}
const _hoisted_87 = { class: "menu-link" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-signature fs-3" })
], -1)
const _hoisted_89 = { class: "menu-title" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_91 = { class: "menu-sub menu-sub-accordion" }
const _hoisted_92 = { class: "menu-item" }
const _hoisted_93 = ["href", "onClick"]
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_95 = { class: "menu-title" }
const _hoisted_96 = { class: "menu-item" }
const _hoisted_97 = ["href", "onClick"]
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_99 = { class: "menu-title" }
const _hoisted_100 = { class: "menu-item" }
const _hoisted_101 = ["href", "onClick"]
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marked-alt fs-3" })
], -1)
const _hoisted_103 = { class: "menu-title" }
const _hoisted_104 = { class: "menu-item" }
const _hoisted_105 = ["href", "onClick"]
const _hoisted_106 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lightbulb fs-3" })
], -1)
const _hoisted_107 = { class: "menu-title" }
const _hoisted_108 = { class: "menu-item" }
const _hoisted_109 = ["href", "onClick"]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chalkboard-teacher fs-3" })
], -1)
const _hoisted_111 = { class: "menu-title" }
const _hoisted_112 = {
  class: "menu-item menu-accordion",
  "data-kt-menu-sub": "accordion",
  "data-kt-menu-trigger": "click"
}
const _hoisted_113 = ["href", "onClick"]
const _hoisted_114 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-solid fa-binoculars fs-3" })
], -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Résultats", -1)
const _hoisted_116 = [
  _hoisted_114,
  _hoisted_115
]
const _hoisted_117 = {
  class: "menu-item menu-accordion",
  "data-kt-menu-sub": "accordion",
  "data-kt-menu-trigger": "click"
}
const _hoisted_118 = ["href", "onClick"]
const _hoisted_119 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-solid fa-binoculars fs-3" })
], -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Gestion des campagnes", -1)
const _hoisted_121 = [
  _hoisted_119,
  _hoisted_120
]
const _hoisted_122 = {
  class: "menu-item menu-accordion",
  "data-kt-menu-sub": "accordion",
  "data-kt-menu-trigger": "click"
}
const _hoisted_123 = { class: "menu-link" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye fs-3" })
], -1)
const _hoisted_125 = { class: "menu-title" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_127 = { class: "menu-sub menu-sub-accordion" }
const _hoisted_128 = { class: "menu-item" }
const _hoisted_129 = ["href", "onClick"]
const _hoisted_130 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_131 = { class: "menu-title" }
const _hoisted_132 = { class: "menu-item" }
const _hoisted_133 = ["href", "onClick"]
const _hoisted_134 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_135 = { class: "menu-title" }
const _hoisted_136 = { class: "menu-item" }
const _hoisted_137 = ["href", "onClick"]
const _hoisted_138 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_139 = { class: "menu-title" }
const _hoisted_140 = { class: "menu-item" }
const _hoisted_141 = ["href", "onClick"]
const _hoisted_142 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_143 = { class: "menu-title" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "separator mx-1 my-4" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/dashboard/" }, {
          default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
            _createElementVNode("a", {
              class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
              href: href,
              onClick: navigate
            }, [
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("pages.dashboard.title")), 1)
            ], 10, _hoisted_4)
          ]),
          _: 1
        })
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("layout.aside.managerSection")), 1)
        ])
      ]),
      (this.$store.getters.currentUser.user.userprofile.user_type.position === 1 || this.$store.getters.currentUser.services.indexOf('drive') !== -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_router_link, { to: "/drive/" }, {
              default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                _createElementVNode("a", {
                  class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                  href: href,
                  onClick: navigate
                }, [
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("pages.dashboard.drive")), 1)
                ], 10, _hoisted_12)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (this.$store.getters.currentUser.user.userprofile.user_type.position === 1 || this.$store.getters.currentUser.services.indexOf('attendance') !== -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_router_link, { to: "/attendance-monitoring/" }, {
              default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                _createElementVNode("a", {
                  class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                  href: href,
                  onClick: navigate
                }, [
                  _hoisted_17,
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("pages.dashboard.attendanceMonitoring")), 1)
                ], 10, _hoisted_16)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (this.$store.getters.currentUser.user.userprofile.user_type.position === 1 || this.$store.getters.currentUser.services.indexOf('results') !== -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_component_router_link, { to: "/results/" }, {
              default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                _createElementVNode("a", {
                  class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                  href: href,
                  onClick: navigate
                }, [
                  _hoisted_21,
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("pages.dashboard.results")), 1)
                ], 10, _hoisted_20)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (this.$store.getters.currentUser.user.userprofile.user_type.position === 1 || this.$store.getters.currentUser.services.indexOf('roadmap') !== -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createVNode(_component_router_link, { to: "/roadmap/" }, {
              default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                _createElementVNode("a", {
                  class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                  href: href,
                  onClick: navigate
                }, [
                  _hoisted_25,
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("pages.roadmap.title")), 1)
                ], 10, _hoisted_24)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (this.$store.getters.currentUser.user.userprofile.user_type.position === 1 || this.$store.getters.currentUser.services.indexOf('ideas_box') !== -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createVNode(_component_router_link, { to: "/ideas/" }, {
              default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                _createElementVNode("a", {
                  class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                  href: href,
                  onClick: navigate
                }, [
                  _hoisted_29,
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("pages.ideas.title")), 1)
                ], 10, _hoisted_28)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (this.$store.getters.currentUser.user.userprofile.user_type.position === 1 || this.$store.getters.currentUser.services.indexOf('useful-training') !== -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createVNode(_component_router_link, { to: "/useful-training/" }, {
              default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                _createElementVNode("a", {
                  class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                  href: href,
                  onClick: navigate
                }, [
                  _hoisted_33,
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("pages.usefulTraining.title")), 1)
                ], 10, _hoisted_32)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (this.$store.getters.currentUser.services.indexOf('survey') !== -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createVNode(_component_router_link, { to: "/surveys/" }, {
              default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                _createElementVNode("a", {
                  class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                  href: href,
                  onClick: navigate
                }, [
                  _hoisted_37,
                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("pages.surveys.title")), 1)
                ], 10, _hoisted_36)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (
                    this.$store.getters.currentUser.user.userprofile.user_type.position === 1 ||
                    this.$store.getters.currentUser.services.indexOf('users') !== -1 ||
                    this.$store.getters.currentUser.services.indexOf('entities') !== -1
                )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("layout.aside.respSection")), 1)
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (this.$store.getters.currentUser.user.userprofile.user_type.position === 1 || this.$store.getters.currentUser.services.indexOf('users') !== -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_component_router_link, { to: "/users/" }, {
                default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                  _createElementVNode("a", {
                    class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                    href: href,
                    onClick: navigate
                  }, [
                    _hoisted_46,
                    _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t("pages.dashboard.users")), 1)
                  ], 10, _hoisted_45)
                ]),
                _: 1
              })
            ]),
            (this.$store.getters.currentUser.user.userprofile.user_type.position === 1 || this.$store.getters.currentUser.services.indexOf('entities') !== -1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createVNode(_component_router_link, { to: "/entities/" }, {
                    default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                      _createElementVNode("a", {
                        class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                        href: href,
                        onClick: navigate
                      }, [
                        _hoisted_50,
                        _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t("pages.dashboard.entities")), 1)
                      ], 10, _hoisted_49)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (this.$store.getters.currentUser.user.userprofile.user_type.position === 1 || this.$store.getters.currentUser.services.indexOf('notifications') !== -1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createVNode(_component_router_link, { to: "/notifications/" }, {
                    default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                      _createElementVNode("a", {
                        class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                        href: href,
                        onClick: navigate
                      }, [
                        _hoisted_54,
                        _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t("pages.dashboard.notifications")), 1)
                      ], 10, _hoisted_53)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (this.$store.getters.currentUser.user.userprofile.user_type.position === 1 || this.$store.getters.currentUser.services.indexOf('statistics') !== -1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createElementVNode("span", _hoisted_57, [
                    _hoisted_58,
                    _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t("pages.statistics.title")), 1),
                    _hoisted_60
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createVNode(_component_router_link, { to: "/statistics/users/" }, {
                        default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                          _createElementVNode("a", {
                            class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                            href: href,
                            onClick: navigate
                          }, [
                            _hoisted_64,
                            _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t("pages.userstatistics.title")), 1)
                          ], 10, _hoisted_63)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _createVNode(_component_router_link, { to: "/statistics/roadmaps/" }, {
                        default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                          _createElementVNode("a", {
                            class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                            href: href,
                            onClick: navigate
                          }, [
                            _hoisted_68,
                            _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$t("pages.roadmapstatistics.title")), 1)
                          ], 10, _hoisted_67)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_70,
      (this.$store.getters.currentUser.user.userprofile.user_type.position === 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.$t("layout.aside.admin")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_74, [
              _createVNode(_component_router_link, { to: "/administration/settings/" }, {
                default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                  _createElementVNode("a", {
                    class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                    href: href,
                    onClick: navigate
                  }, [
                    _hoisted_76,
                    _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.$t("pages.settings.altTitle")), 1)
                  ], 10, _hoisted_75)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createVNode(_component_router_link, { to: "/administration/access/" }, {
                default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                  _createElementVNode("a", {
                    class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                    href: href,
                    onClick: navigate
                  }, [
                    _hoisted_80,
                    _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$t("pages.usersAccess.title")), 1)
                  ], 10, _hoisted_79)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_82, [
              _createVNode(_component_router_link, { to: "/administration/users/" }, {
                default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                  _createElementVNode("a", {
                    class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                    href: href,
                    onClick: navigate
                  }, [
                    _hoisted_84,
                    _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.$t("pages.dashboard.users")), 1)
                  ], 10, _hoisted_83)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("span", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.$t("layout.aside.docsManagement")), 1),
                _hoisted_90
              ]),
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, [
                  _createVNode(_component_router_link, { to: "/administration/documents/documents/" }, {
                    default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                      _createElementVNode("a", {
                        class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                        href: href,
                        onClick: navigate
                      }, [
                        _hoisted_94,
                        _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.$t("pages.driveManagement.documents.title")), 1)
                      ], 10, _hoisted_93)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _createVNode(_component_router_link, { to: "/administration/documents/categories/" }, {
                    default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                      _createElementVNode("a", {
                        class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                        href: href,
                        onClick: navigate
                      }, [
                        _hoisted_98,
                        _createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.$t("pages.driveManagement.categories.title")), 1)
                      ], 10, _hoisted_97)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _createVNode(_component_router_link, { to: "/administration/roadmapcategory/" }, {
                default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                  _createElementVNode("a", {
                    class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                    href: href,
                    onClick: navigate
                  }, [
                    _hoisted_102,
                    _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.$t("layout.aside.roadmapThemes")), 1)
                  ], 10, _hoisted_101)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_104, [
              _createVNode(_component_router_link, { to: "/administration/ideabox/" }, {
                default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                  _createElementVNode("a", {
                    class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                    href: href,
                    onClick: navigate
                  }, [
                    _hoisted_106,
                    _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.$t("pages.ideas.title")), 1)
                  ], 10, _hoisted_105)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_108, [
              _createVNode(_component_router_link, { to: "/administration/usefultraining/" }, {
                default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                  _createElementVNode("a", {
                    class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                    href: href,
                    onClick: navigate
                  }, [
                    _hoisted_110,
                    _createElementVNode("span", _hoisted_111, _toDisplayString(_ctx.$t("pages.usefulTraining.title")), 1)
                  ], 10, _hoisted_109)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_112, [
              _createVNode(_component_router_link, { to: "/administration/results/" }, {
                default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                  _createElementVNode("a", {
                    class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                    href: href,
                    onClick: navigate
                  }, _hoisted_116, 10, _hoisted_113)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_117, [
              _createVNode(_component_router_link, { to: "/administration/campaigns/" }, {
                default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                  _createElementVNode("a", {
                    class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                    href: href,
                    onClick: navigate
                  }, _hoisted_121, 10, _hoisted_118)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_122, [
              _createElementVNode("span", _hoisted_123, [
                _hoisted_124,
                _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.$t("layout.aside.surveys")), 1),
                _hoisted_126
              ]),
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("div", _hoisted_128, [
                  _createVNode(_component_router_link, { to: "/administration/surveys/list/" }, {
                    default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                      _createElementVNode("a", {
                        class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                        href: href,
                        onClick: navigate
                      }, [
                        _hoisted_130,
                        _createElementVNode("span", _hoisted_131, _toDisplayString(_ctx.$t("pages.surveys.title")), 1)
                      ], 10, _hoisted_129)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_132, [
                  _createVNode(_component_router_link, { to: "/administration/surveys/questions/" }, {
                    default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                      _createElementVNode("a", {
                        class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                        href: href,
                        onClick: navigate
                      }, [
                        _hoisted_134,
                        _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.$t("pages.surveys.questions.title")), 1)
                      ], 10, _hoisted_133)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_136, [
                  _createVNode(_component_router_link, { to: "/administration/surveys/question-tags/" }, {
                    default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                      _createElementVNode("a", {
                        class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                        href: href,
                        onClick: navigate
                      }, [
                        _hoisted_138,
                        _createElementVNode("span", _hoisted_139, _toDisplayString(_ctx.$t("pages.surveys.questiontags.title")), 1)
                      ], 10, _hoisted_137)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_140, [
                  _createVNode(_component_router_link, { to: "/administration/surveys/languages/" }, {
                    default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                      _createElementVNode("a", {
                        class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link"]),
                        href: href,
                        onClick: navigate
                      }, [
                        _hoisted_142,
                        _createElementVNode("span", _hoisted_143, _toDisplayString(_ctx.$t("pages.surveys.language.title")), 1)
                      ], 10, _hoisted_141)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _hoisted_144
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 512))
}